import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles,useTheme } from '@material-ui/styles';

import {
  AppBar,
  Box,
  Card,
  Button,
  Avatar,
  Table, 
  TableBody,
  TableCell,
  TableContainer, 
  TableHead,
  TableRow,	 
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,	
  DialogActions,
  Grid,
  Typography,
  Paper,
  Popover,
  Tabs,
  Tab,
  IconButton
} from '@material-ui/core';

import { Icon, InlineIcon } from '@iconify/react';
import StravaIcon from '@iconify/icons-mdi/strava';

import i18n from 'i18next';
import _, { set } from 'lodash';
import axios from 'axios';
import auth from '../../../../utils/auth';
import { useTranslation } from 'react-i18next';

//jQuery 추가 
import $ from "jquery";

//Chart 추가
import CanvasJSReact from '../../../../utils/canvasjs.stock.react';
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
var CanvasJSStockChart = CanvasJSReact.CanvasJSStockChart;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  tableContainer:{
    height: 300,
    fontSize:'13px',
    margin: '12px 0px 12px 0px',
    padding: '4px', 
    overflow:'auto',
    [theme.breakpoints.down("lg")]: {
      padding: '4px 8px',
      fontSize:'12px',
      height: 240,
    },
    [theme.breakpoints.down("sm")]: {
      padding: '4px 8px',
      fontSize:'12px',
      height: 200,
    },
  },
  tableHeadCell: {
    padding:'6px 8px', 
    color:'#4db6ac',		
    fontSize:'13px',
    fontWeight:'400',
    backgroundColor:'#f9f9f9',
    whiteSpace:'nowrap',
    textOverflow:'ellipsis',
    [theme.breakpoints.down("md")]: {
      padding: '4px 4px',
      fontSize:'12px'
    },
    [theme.breakpoints.down("sm")]: {
      padding: '2px 4px',
      fontSize:'12px'
    },		
  },
  tableCell: {
    fontSize:'13px',
    padding:'6px 8px',
    whiteSpace:'nowrap',
    textOverflow:'ellipsis',
    [theme.breakpoints.down("md")]: {
      padding: '4px 4px',
      fontSize:'12px'
    },
    [theme.breakpoints.down("sm")]: {
      padding: '2px 4px',
      fontSize:'12px'
    },		
  },  
  stravaButton : {		
    minWidth:0, margin:'2px 2px 2px 0'
  },
  stravaIcon: {
    color:'#FC4C02',
    fontSize:'16px',
    opacity:'0.7',
    marginTop:'-2px'
  },  
  tabPanel: {
    padding: '16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '0 0 4px 4px'
  },
  gridContainer : {
    color:'#999999',
    fontWeight:300,
    fontSize:'13px',   
    [theme.breakpoints.down("sm")]: {
      fontSize:'11px'
    }
  },   
  descTitle : {
    marginBottom: '8px'
  }, 
  tableCellPower : {
    display: "inline-block",
    padding:5,
    minWidth:80,
    borderRadius:10,
    color: "#ffffff",
    fontWeight:600,
    fontSize:13,
  },
  tableCellColorBox : {
    display:'inline-block', 
    width:12, 
    height:12, 
    marginRight: 12,
  }
}));

const PowerProfile = props => {
  const { activityData, pdcData, ftpArray, wkg, weight, wkgSelect } = props;
  const classes = useStyles();

  //다국어적용
  const { t }  = useTranslation(['page']);
  const language = i18n.language;

  const ftp = ftpArray.ftp; 
  const tte = ftpArray.tte; 

  const bestIndex = ftpArray.best_index;

  const [ powerCurveOptions, setPowerCurveOptions ] = React.useState(null);
  const [ powerCurveData, setPowerCurveData ] = React.useState([]);
  const [ powerCurveViewDuration, setPowerCurveViewDuration ] = useState(1);

  const powerCurveDurationArray = [1, 5, 15, 30, 60, 120, 180, 240, 300, 360, 420, 480, 540, 600, 720, 900, 1200, 1500, 1800, 2400, 3600, 7200, 14400];

  let key = 0;

  const containerCurve = {
    minWidth: '300px',
    height: (window.innerHeight > 800) ? "360px" : "240px",
    margin: "0 auto 10px auto"
  };

  useEffect(() => {
    if(auth.getToken() !== null) {
      const auth_str = 'Bearer '.concat((auth.getToken().token)); 

      axios.post(
        `${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/get-power-curve.php`, 
        {},
        { 
          headers: { Authorization: auth_str }, 
        }
      ).then(response => {
        if(!!response.data && response.data.length > 0) {
          setPowerCurveData(response.data.reverse());
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }, []);

  useEffect(() => {

    const stripLineX = [];
    const stripLineY = [];

    let stripLinesData = [];
    let period_data_arr = [];
    let period_name = [];

    powerCurveData.map((item, index) => {
      
      let period_data_duration_arr = [];
      period_name[index] = item.start_date + '~' + item.end_date;
      let maxFtp = powerCurveData[index].data.max_ftp;

      let period_color = (index===0)?"#f06292":(index===1)?"#76B5E8":"#FFD357"
      stripLinesData.push({
        showOnTop: true,
        value: (wkgSelect) ? Math.round(10*maxFtp/weight)/10: maxFtp, 
        label: (wkgSelect) ? 'FTP ' + Math.round(10*maxFtp/weight)/10 + ' w/kg' : 'FTP ' + maxFtp + ' W', 
        labelPlacement:"inside",
        labelFontSize: 12,
        labelAlign: (index===0)?"far":(index===1)?"center":"near",
        labelFontColor: period_color,
        thickness:1,
        color:period_color,
        lineDashType:'dash'
      })

      powerCurveDurationArray.map((duration) => {
        let power_duration_key = (duration > 1)? `max_watts_${duration}`:'max_max_watts'
        let power = 0
        
        power = (wkgSelect) ? Math.round(10*powerCurveData[index]?.data[power_duration_key]/weight)/10 : Math.round(powerCurveData[index]?.data[power_duration_key])
        period_data_duration_arr.push({'x' : Math.round(duration), 'y' : power, 'value' : power, label : period_name[index]});

      });
      period_data_arr.push(period_data_duration_arr);
    });

    // function onMouseOver(e){
    //   setPowerCurveViewDuration(e.dataPoint.x)
    // }

    // function onItemMouseOver(e){
    //   e.chart.data[0].set('visible', false);
    //   e.chart.data[1].set('visible', false);
    //   e.chart.data[2].set('visible', false);

    //   e.chart.data[e.dataSeriesIndex].set('visible', true);
    // }

    // function onItemMouseOut(e){
    //   e.chart.data[0].set('visible', true);
    //   e.chart.data[1].set('visible', true);
    //   e.chart.data[2].set('visible', true);
    // } 

    setPowerCurveOptions({
      animationEnabled: false,
      theme: "light2", 
      title: false,
      zoomEnabled: false,
      dataPointMaxWidth: 16,
      toolTip:{
        shared: true,      
        contentFormatter: function(e) {
          let content = secondsToHms(e.entries[0].dataPoint.x)
          setPowerCurveViewDuration(e.entries[0].dataPoint.x)
          // if(e.entries.length > 0) for (let i = 0; i < e.entries.length; i++) {           
          //   content += "<div style='color:" + e.entries[i].dataSeries.color + "'>" +
          //                 e.entries[i].dataSeries.name + " " + "<strong>" + e.entries[i].dataPoint.value + "</strong>" + 
          //               "</div>";
          // }
          return content;
        }
      },
      axisX:{
        maximum:3600, 
        logarithmic: true,
        logarithmBase: 2,
        dataPointMaxWidth: 20,
        labelAutoFit: false,
        suffix: "",
        lineThickness: 1,
        lineColor:"#aaaaaa",
        gridThickness: 1,
        gridColor: "#eeeeee",
        labelFontSize: 12,
        labelFontColor: "#aaaaaa",
        labelFormatter: function(e){return secondsToHms(e.value)},
        labelAngle: 0,
        crosshair: {
          enabled: true,
          snapToDataPoint: true,
          lineColor: "#999999",
          labelFormatter: function(e){
            return secondsToHms(e.value);
          },
        },
      },
      axisY:{
        stripLines : stripLinesData,
        margin:10, 
        labelFontSize: 12,
        labelFontColor: "#aaaaaa",
        tickLength: 2,
        lineThickness: 1,
        lineColor:"#aaaaaa",
        suffix: (wkgSelect) ? " w/kg" : " W",
        gridThickness: 1,
        gridColor: "#eeeeee",
        minimum : 0,
      },
      legend:{
        horizontalAlign: "center", 
        verticalAlign: "bottom",  
        fontSize: 12,
        fontColor: "#666666",
      },				
      data: [
        {
          name: period_name[0],
          type: "line",
          showInLegend: true, 
          legendMarkerType: "circle",
          connectNullData:true,			
          indexLabelFontColor: "#f06292",
          indexLabelBackgroundColor: "#CCCCCC",
          color:"#f06292",
          lineColor:"#f06292",
          lineThickness: 2,
          fillOpacity: "1", 
          markerSize: 6,
          markerColor: "#f06292",
          markerBorderColor: "#ffffff",
          markerBorderThickness: 1,
          dataPoints: period_data_arr[0],
          // mouseover: onMouseOver,
        },
        {
          name: period_name[1],
          type: "line",
          showInLegend: true, 
          legendMarkerType: "circle",
          connectNullData:true,			
          color:"#76B5E8",
          lineColor:"#76B5E8",
          lineThickness: 2,
          fillOpacity: "1", 
          markerSize: 6,
          markerColor: "#76B5E8",
          markerBorderColor: "#ffffff",
          markerBorderThickness: 1,
          dataPoints: period_data_arr[1],
          // mouseover: onMouseOver,
        },
        {
          name: period_name[2],
          type: "line",
          showInLegend: true, 
          legendMarkerType: "circle",
          connectNullData:true,			
          color:"#FFD357",
          lineColor:"#FFD357",
          lineThickness: 2,
          fillOpacity: "1", 
          markerSize: 6,
          markerColor: "#FFD357",
          markerBorderColor: "#ffffff",
          markerBorderThickness: 1,
          dataPoints: period_data_arr[2],
          // mouseover: onMouseOver,
        },
      ]
    });
  
    stripLineY.push({type:"dash", value:0, color: "#000000", lineDashType:"dash", lineThickness:2, lineColor:"#333333"}); 
  }, [wkgSelect, powerCurveData]);

  function secondsToHms(time) {
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    
    if(h > 0) {
      let hd = h > 0 ? h + t('Common.hour') + " " : "";
      let md = m > 0 ? m + t('Common.min') : "";
      
      return hd + md; 
    } else if(h <= 0) {
      let md = m > 0 ? m + t('Common.min') + " " : "";
      let sd = s > 0 ? s + t('Common.sec') : "";
      
      return md + sd; 
    }
  }
  
  function secondsToHmsLabel(time) {
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    
    if(h == 0 && m == 0 && s == 0) {
      return ""; 
    } else if(h > 0) {
      let hd = h > 0 ? h + ":" : "00";
      let md = m > 0 ? m : "00";
      
      return hd + md; 
    } else if(h <= 0) {
      let md = m > 0 ? m + ":" : "";
      let sd = s > 0 ? s : "00";
      
      return md + sd; 
    } 
  }	

  function PowerTable(props) {
    const powerCurveArray = props.powerCurveArray;
    const wkgSelect = props.wkgSelect;
    const powerCurveViewDuration = props.powerCurveViewDuration;

    return (
      <TableContainer component={Paper} id={"activityTable"} className={classes.tableContainer}>
      <Table className={classes.table} aria-label="table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeadCell} align="center" style={{width:'40%'}}>{t('Powerprofile.period')}</TableCell>
            <TableCell className={classes.tableHeadCell} align="center" style={{width:'20%'}}>{t('Powerprofile.second')}</TableCell>
            <TableCell className={classes.tableHeadCell} align="center" style={{width:'20%'}}>{t('Powerprofile.power')}</TableCell>
            <TableCell className={classes.tableHeadCell} align="center" style={{width:'20%'}}>{t('Powerprofile.maxFtp')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{maxHeight:"400px"}}>
        {powerCurveArray.map((item) => {
            key++;

            let power_duration_key = (powerCurveViewDuration > 1)? `max_watts_${powerCurveViewDuration}`:'max_max_watts'

            let period_name = item.start_date + '~' + item.end_date;
            let period_max_ftp = item.data.max_ftp;
            let period_power = item.data[power_duration_key];
            let period_color = (key===1)?"#f06292":(key===2)?"#76B5E8":"#FFD357"

            return (
              <TableRow key={key} id={key}>
                <TableCell className={classes.tableCell} align="center">
                  <div className={classes.tableCellColorBox} style={{backgroundColor:period_color}}></div>
                  {period_name}
                </TableCell>
                <TableCell className={classes.tableCell} align="center">
                  {secondsToHms(powerCurveViewDuration)}
                </TableCell>
                <TableCell className={classes.tableCell} align="center">
                  <div className={classes.tableCellPower} style={{backgroundColor:period_color}}>
                    {(wkgSelect) ? Math.round(10*period_power/weight)/10 + " w/kg" : period_power + " W"} 
                  </div>
                </TableCell>
                <TableCell className={classes.tableCell} align="center">
                  {(wkgSelect) ? Math.round(10*period_max_ftp/weight)/10 + " w/kg" : period_max_ftp + " W"} 
                </TableCell>
              </TableRow>
            );
          }
        )}
        </TableBody>
      </Table>
      </TableContainer>
    );
  }

  return(
    <React.Fragment>
      <Box className={classes.tabPanel}>
        <CanvasJSChart containerProps={containerCurve} options={powerCurveOptions} />
        <Divider />

        <PowerTable powerCurveArray={powerCurveData} wkgSelect={wkgSelect} powerCurveViewDuration={powerCurveViewDuration}/>

        <Box style={{padding:'12px 0px'}}>
          <Typography className={classes.desc} component="div"> 
            {t('Powerprofile.PowerPeriodDesc1')}
          </Typography> 
          <Typography className={classes.desc} component="div"> 
            {t('Powerprofile.PowerPeriodDesc2')}
          </Typography> 
          <Typography className={classes.desc} component="div"> 
            {t('Powerprofile.PowerPeriodDesc3')}
          </Typography> 
        </Box>		
        <Divider />
      </Box>
    </React.Fragment>
  );

};

PowerProfile.propTypes = {
  history: PropTypes.object
};

export default withRouter(PowerProfile);
